import { render, staticRenderFns } from "./SelectInitialCards.vue?vue&type=template&id=503b8489"
import script from "./SelectInitialCards.vue?vue&type=script&lang=ts"
export * from "./SelectInitialCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports